const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = 3600;

/** `startSecond` of a cited turn, as `mm:ss` — `h:mm:ss` past the hour mark. */
const formatEvidenceTimestamp = (totalSeconds: number): string => {
	const hours = Math.floor(totalSeconds / SECONDS_PER_HOUR);
	const minutes = Math.floor((totalSeconds % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE);
	const seconds = Math.floor(totalSeconds % SECONDS_PER_MINUTE);
	const paddedSeconds = String(seconds).padStart(2, '0');

	if (hours > 0) {
		const paddedMinutes = String(minutes).padStart(2, '0');

		return `${hours}:${paddedMinutes}:${paddedSeconds}`;
	}

	return `${minutes}:${paddedSeconds}`;
};

export default formatEvidenceTimestamp;
